import App from './App';
import React from 'react';
import getFirebaseConfig from './firebase/config';
import { initializeCustomData } from './utils/customData';
import { captureClickIdsFromUrl } from './utils/adIdentifiers';
import { initializeApp } from '@firebase/app';
import { createRoot } from 'react-dom/client';
import {
  CartProvider,
  ThemeProvider,
  GlobalProvider,
  APICacheProvider,
  CookieConsentProvider,
  SuccessDrawerProvider,
} from './context';
import 'simplebar-react/dist/simplebar.min.css';
import 'assets/tailwind.css';
import 'focus-visible';
import './i18n';

const firebaseConfig = getFirebaseConfig();

initializeApp(firebaseConfig);
initializeCustomData();
captureClickIdsFromUrl();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <APICacheProvider>
      <ThemeProvider>
        <CookieConsentProvider>
          <GlobalProvider>
            <CartProvider>
              <SuccessDrawerProvider>
                <App />
              </SuccessDrawerProvider>
            </CartProvider>
          </GlobalProvider>
        </CookieConsentProvider>
      </ThemeProvider>
    </APICacheProvider>
  </React.StrictMode>
);
